import ImagePreview from "./ImagePreview";
import G from './Getters';
import { useStore } from 'react-redux';

export default function ImageSetImageDisplay({imageSetId}){
  let store = useStore();
  let state = store.getState();

  let {images} = G.getImageSet(state,imageSetId);



  return (
    <div class="rel" style={{
      display:'flex',
      flexWrap:'wrap',
      width:'80%',
    }}>
      {images.map(imageId => {
        return (
          <div style={{
            maxWidth:(100/images.length)+'%',
            paddingRight:15,
          }}>
          <ImagePreview imageId={imageId}/>
          </div>
        )
      })}
    </div>
  )


}
